import { Controller } from "@hotwired/stimulus"

// Fills the Event Snaps album preview on the Guest List tab: tiles pop in one
// by one while a feed line names the organizer's own guests adding photos.
// Starts when the card scrolls into view; Replay runs it again. With reduced
// motion the finished album is shown straight away.
const TILES = 12
const TILE_STYLES = [
  "linear-gradient(135deg,#FFDAD6,#FF958C)", "linear-gradient(135deg,#DDEAF0,#84B8CF)",
  "linear-gradient(135deg,#E4E0FF,#A79BFF)", "linear-gradient(135deg,#FDE68A,#F59E0B)",
  "linear-gradient(135deg,#B8D3DF,#1F4D64)", "linear-gradient(135deg,#FFB8B1,#C94941)",
  "linear-gradient(135deg,#A7F3D0,#059669)", "linear-gradient(135deg,#F3F3EF,#BAC3D1)",
  "linear-gradient(135deg,#C9C2FF,#4A3B98)", "linear-gradient(135deg,#FF786C,#7A2C28)",
  "linear-gradient(135deg,#5B9FBF,#0C202B)", "linear-gradient(135deg,#FFF1EF,#FF6B5E)"
]

export default class extends Controller {
  static targets = ["grid", "feed", "count", "avatar"]
  static values = { names: Array, interval: { type: Number, default: 550 } }

  connect() {
    this.observer = new IntersectionObserver((entries) => {
      if (entries.some(entry => entry.isIntersecting)) {
        this.play()
        this.observer.disconnect()
      }
    }, { threshold: 0.3 })
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    this.stop()
  }

  replay() {
    this.play()
  }

  play() {
    this.stop()
    this.gridTarget.innerHTML = ""
    this.step = 0

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      while (this.step < TILES) this.addTile()
      this.finish()
      return
    }

    this.timer = setInterval(() => {
      if (this.step >= TILES) { this.finish(); return }
      this.addTile()
    }, this.intervalValue)
  }

  stop() {
    if (this.timer) clearInterval(this.timer)
    this.timer = null
  }

  addTile() {
    const i = this.step
    const tile = document.createElement("div")
    tile.className = "aspect-square rounded-md flex items-center justify-center text-white/70 event-snaps-tile"
    tile.style.background = TILE_STYLES[i % TILE_STYLES.length]
    tile.innerHTML = '<i class="ph ph-image"></i>'
    this.gridTarget.appendChild(tile)

    this.step = i + 1
    const name = this.names[i % this.names.length]
    const added = 1 + (i % 3)
    this.feedTarget.textContent = `${name} added ${added} ${added === 1 ? "photo" : "photos"} · just now`
    this.avatarTarget.textContent = name.charAt(0)
    this.countTarget.textContent = String(this.step * 3 - 2)
  }

  finish() {
    this.stop()
    this.feedTarget.textContent = "Album saved to your event"
  }

  get names() {
    return this.namesValue.length ? this.namesValue : ["A guest"]
  }
}
